import Splide from '@splidejs/splide';

const mountInstallationSlider = (el) => {
  new Splide(el, {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    speed: 600,
    rewind: true,
    arrows: false,
    pagination: true,
    destroy: true,
    classes: {
      pagination: 'splide__pagination installation-slider__pagination',
      page: 'splide__pagination__page installation-slider__pagination-btn',
    },
    breakpoints: {
      1024: {
        destroy: false,
      },
    },
  }).mount();
};

export const initInstallationSlider = () => {
  const installationSliderEl = document.querySelector(
    '[data-installation-slider]'
  );

  mountInstallationSlider(installationSliderEl);
};
